import type { Ref } from 'vue'
import type { WalletInteractionHooks } from './contracts'

export interface WalletsApi {
  needsTonReconnect: Readonly<Ref<boolean>>
  connectEvm: () => Promise<void>
  connectEvmForComposite: () => Promise<void>
  disconnectEvm: () => Promise<void>
  switchEvm: (chainId: number) => Promise<void>
  connectSolana: () => Promise<void>
  connectPhantom: () => Promise<void>
  disconnectSolana: () => Promise<void>
  connectTon: (address: string) => void
  disconnectTon: () => void
  syncTonSession: () => void
  prewarmEvm: () => Promise<void>
  activateSolana: () => Promise<void>
  isAllowedRedirect: (url: string) => boolean
}

export interface WalletBindingsOwner {
  wire: (hooks: WalletInteractionHooks) => void
  dispose: () => void
}

let installedApi: WalletsApi | null = null
let installedBindings: WalletBindingsOwner | null = null

export const installWallets = (api: WalletsApi, bindings: WalletBindingsOwner): void => {
  installedApi = api
  installedBindings = bindings
}

export const getWallets = (): WalletsApi => {
  if (!installedApi) throw new Error('crosschain_wallets_not_installed')
  return installedApi
}

export const getWalletBindings = (): WalletBindingsOwner => {
  if (!installedBindings) throw new Error('crosschain_wallet_bindings_not_installed')
  return installedBindings
}
